import {GET_LAYOFF_ADRESS} from "../../../enums/Request/request.types";

export const getUsersAdressAction = (data) => {
    return {
        type: GET_LAYOFF_ADRESS,
        payload: data,
    };
};
